var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fund-selector',{on:{"fund-selected":function($event){return _vm.onFundSelected($event)}}}),(_vm.selectedFund)?_c('data-source-conflicts',{ref:"DataSourceConflicts",attrs:{"fund":_vm.selectedFund}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }